import { GoalBasedFinancialPlanExpenseResponse } from "@fartherfinance/frontend/api/FinancialPlans/expenses/types";

import { approachOptions } from "../../Expenses/Types";
import {
  ApproachField,
  AutoTransportField,
  BillsUtilitiesField,
  BusinessField,
  CharitableGivingField,
  DiningOutField,
  EducationField,
  EntertainmentField,
  ExpensePeriodField,
  FeesChargesField,
  GiftField,
  GroceriesField,
  HealthFitnessField,
  KidsField,
  MiscField,
  NameField,
  OwnerField,
  RentField,
  ShoppingField,
  TargetAmountField,
  TravelField,
  UncategorizedField,
} from "../constants";
import {
  AnnualIncreaseAmountField,
  AnnualIncreaseTypeField,
  annualIncreaseTypeOptions,
  isCustomInflation,
} from "../MultiDropdown/AnnualIncrease/AnnualIncrease";

interface Params {
  expense: GoalBasedFinancialPlanExpenseResponse;
}

export const populateLivingExpenseFormFields = ({ expense }: Params) => {
  const {
    annualIncrease,
    amount,
    expenseType,
    livingExpenses,
    name,
    owner,
    period,
  } = expense;

  const annualIncreaseTypeField = annualIncreaseTypeOptions.find(
    ({ value }) => annualIncrease?.type === value
  );

  const annualIncreaseAmountField = isCustomInflation(annualIncrease)
    ? annualIncrease.value
    : undefined;

  const approachField =
    expenseType === "SimpleLiving" ? approachOptions[0] : approachOptions[1];

  return {
    [AnnualIncreaseTypeField]: annualIncreaseTypeField,
    [AnnualIncreaseAmountField]: annualIncreaseAmountField,
    [NameField]: name,
    [OwnerField]: { label: "Shared", value: owner },
    [TargetAmountField]: amount,
    [ExpensePeriodField]: period,
    [ApproachField]: approachField,
    [AutoTransportField]: livingExpenses?.expenses.autoTransport,
    [BillsUtilitiesField]: livingExpenses?.expenses.billsUtilities,
    [BusinessField]: livingExpenses?.expenses.businessExpenses,
    [CharitableGivingField]: livingExpenses?.expenses.charitableGiving,
    [DiningOutField]: livingExpenses?.expenses.diningOut,
    [EducationField]: livingExpenses?.expenses.education,
    [EntertainmentField]: livingExpenses?.expenses.entertainment,
    [FeesChargesField]: livingExpenses?.expenses.feesCharges,
    [GiftField]: livingExpenses?.expenses.gifts,
    [GroceriesField]: livingExpenses?.expenses.groceries,
    [HealthFitnessField]: livingExpenses?.expenses.healthFitness,
    [KidsField]: livingExpenses?.expenses.kids,
    [MiscField]: livingExpenses?.expenses.miscellaneous,
    [RentField]: livingExpenses?.expenses.rent,
    [ShoppingField]: livingExpenses?.expenses.shopping,
    [TravelField]: livingExpenses?.expenses.travel,
    [UncategorizedField]: livingExpenses?.expenses.uncategorized,
  };
};
